import type { QueryParams } from '@/hooks/useQuery'
import { QueryV1, BoolQueryV1 } from '@ttab/elephant-api/index'
import { buildAdvancedQuery } from '@/components/AdvancedSearch/lib/buildQuery'
import { buildFreeTextQuery } from '@/components/AdvancedSearch/lib/freeTextQuery'
import { deserializeAdvancedState, hasAdvancedParams } from '@/components/AdvancedSearch/hooks/useAdvancedSearchParams'
import { factboxFields, dateFields } from '@/components/AdvancedSearch/configs'

export function constructQuery(filter: QueryParams | undefined, timeZone: string): QueryV1 | undefined {
  if (!filter) {
    return undefined
  }

  const query = QueryV1.create({
    conditions: {
      oneofKind: 'bool',
      bool: BoolQueryV1.create({
        must: []
      })
    }
  })

  if (query.conditions.oneofKind !== 'bool') {
    return undefined
  }

  const boolConditions = query.conditions.bool

  if (hasAdvancedParams(filter)) {
    const advQuery = buildAdvancedQuery(
      deserializeAdvancedState(filter, factboxFields),
      factboxFields,
      { field: dateFields.factboxes, timeZone }
    )
    if (advQuery) {
      boolConditions.must.push(advQuery)
    }
  } else if (filter.query) {
    const freeText = buildFreeTextQuery(filter.query.toString(), factboxFields)
    if (freeText) {
      boolConditions.must.push(freeText)
    }
  }

  return query
}
